import React, { Component } from "react";
import { Col, Card, Form } from "antd";
import _ from "lodash";

class CustomerInformationTradeIn extends Component {
  render() {
    const { data } = this.props;
    let name, email, noHp;

    if (data) {
      const { carDetail } = data;
      if (carDetail) {
        name = _.find(carDetail, { fieldName: "Nama Pemilik" });
        email = _.find(carDetail, { fieldName: "Email" });
        noHp = _.find(carDetail, { fieldName: "Nomor Handphone" });
      }
    }
    return (
      <Col xs={24} md={12}>
        <Card title="Costumer Information">
          <Form.Item label="Nama Customer">
            <span className="ant-form-text form-text-mod">
              {name ? name.value : null}
            </span>
          </Form.Item>
          <Form.Item label="Email">
            <span className="ant-form-text form-text-mod">
              {email ? email.value : null}
            </span>
          </Form.Item>
          <Form.Item label="No. Hp">
            <span className="ant-form-text form-text-mod">
              {noHp ? noHp.value : null}
            </span>
          </Form.Item>
        </Card>
      </Col>
    );
  }
}

export default CustomerInformationTradeIn;



// WEBPACK FOOTER //
// src/components/Dashboard/Approval/Component/Section/CustomerInformationTradeIn.js